import DoubleCheckedIcon from 'assets/icons/DoubleCheckedIcon'
import BodyText from 'components/UI/body-text/body-text'
import { Button } from 'components/UI/button/button'
import SubTitle from 'components/UI/sub-title/sub-title'
import Title from 'components/UI/title/title'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setOpenModalAfterBuy } from 'redux/store/slices/application-slice'
import tw from 'twin.macro'
import { pathnames } from 'utils/steps'

function OfflineSuccessPage() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleClose = () => {
    dispatch(setOpenModalAfterBuy(true))

    navigate(pathnames.main)
  }
  return (
    <div tw='relative z-10 bg-secondary sm:min-w-[370px] max-w-[440px] w-full mx-auto rounded-s20 p-8 flex flex-col gap-4 items-center justify-center'>
      <DoubleCheckedIcon />
      <Title variant='bold'>{t('success.title', { ns: 'offlineClient' })}</Title>
      <SubTitle twStyle={tw`text-secondary font-medium text-center`}>
        {t('success.desc', { ns: 'offlineClient' })}
      </SubTitle>
      <Button variant='gradient' onClick={handleClose}>
        {t('success.close', { ns: 'offlineClient' })}
      </Button>
    </div>
  )
}

export default OfflineSuccessPage
